var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOceanIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ocean_Icon",
    "data-name": "Ocean Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 32,
    height: 32,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Paths",
    transform: "translate(2.667 2.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M4.028,9.662h-.05A8.183,8.183,0,0,1-.84,7.454L.93,5.688A6.607,6.607,0,0,0,4,7.162,7.1,7.1,0,0,0,7.625,5.6a1.242,1.242,0,0,1,.922-.28,1.229,1.229,0,0,1,.836.46,4.179,4.179,0,0,0,2.92,1.38A3.635,3.635,0,0,0,15.019,5.84a1.25,1.25,0,0,1,1.808-.232,7.253,7.253,0,0,0,3.8,1.555A4.814,4.814,0,0,0,23.73,5.726l0,.005,1.85,1.682a7.312,7.312,0,0,1-4.953,2.249A8.8,8.8,0,0,1,16.181,8.2a5.988,5.988,0,0,1-3.872,1.461A6.4,6.4,0,0,1,8.3,8.186,8.427,8.427,0,0,1,4.028,9.662Z",
    transform: "translate(0.999 -2.539)",
    fill: "#2666cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59-2",
    "data-name": "Path 59",
    d: "M4.028,9.662h-.05A8.183,8.183,0,0,1-.84,7.454L.93,5.688A6.607,6.607,0,0,0,4,7.162,7.1,7.1,0,0,0,7.625,5.6a1.242,1.242,0,0,1,.922-.28,1.229,1.229,0,0,1,.836.46,4.179,4.179,0,0,0,2.92,1.38A3.635,3.635,0,0,0,15.019,5.84a1.25,1.25,0,0,1,1.808-.232,7.253,7.253,0,0,0,3.8,1.555A4.814,4.814,0,0,0,23.73,5.726l0,.005,1.85,1.682a7.312,7.312,0,0,1-4.953,2.249A8.8,8.8,0,0,1,16.181,8.2a5.988,5.988,0,0,1-3.872,1.461A6.4,6.4,0,0,1,8.3,8.186,8.427,8.427,0,0,1,4.028,9.662Z",
    transform: "translate(0.966 5.845)",
    fill: "#2666cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59-3",
    "data-name": "Path 59",
    d: "M4.028,9.662h-.05A8.183,8.183,0,0,1-.84,7.454L.93,5.688A6.607,6.607,0,0,0,4,7.162,7.1,7.1,0,0,0,7.625,5.6a1.242,1.242,0,0,1,.922-.28,1.229,1.229,0,0,1,.836.46,4.179,4.179,0,0,0,2.92,1.38A3.635,3.635,0,0,0,15.019,5.84a1.25,1.25,0,0,1,1.808-.232,7.253,7.253,0,0,0,3.8,1.555A4.814,4.814,0,0,0,23.73,5.726l0,.005,1.85,1.682a7.312,7.312,0,0,1-4.953,2.249A8.8,8.8,0,0,1,16.181,8.2a5.988,5.988,0,0,1-3.872,1.461A6.4,6.4,0,0,1,8.3,8.186,8.427,8.427,0,0,1,4.028,9.662Z",
    transform: "translate(0.966 14.228)",
    fill: "#2666cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59-4",
    "data-name": "Path 59",
    d: "M4.028,9.662h-.05A8.183,8.183,0,0,1-.84,7.454L.93,5.688A6.607,6.607,0,0,0,4,7.162,7.1,7.1,0,0,0,7.625,5.6a1.242,1.242,0,0,1,.922-.28,1.229,1.229,0,0,1,.836.46,4.179,4.179,0,0,0,2.92,1.38A3.635,3.635,0,0,0,15.019,5.84a1.25,1.25,0,0,1,1.808-.232,7.253,7.253,0,0,0,3.8,1.555A4.814,4.814,0,0,0,23.73,5.726l0,.005,1.85,1.682a7.312,7.312,0,0,1-4.953,2.249A8.8,8.8,0,0,1,16.181,8.2a5.988,5.988,0,0,1-3.872,1.461A6.4,6.4,0,0,1,8.3,8.186,8.427,8.427,0,0,1,4.028,9.662Z",
    transform: "translate(0.966 3.671)",
    fill: "#2666cf",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59-5",
    "data-name": "Path 59",
    d: "M4.028,9.662h-.05A8.183,8.183,0,0,1-.84,7.454L.93,5.688A6.607,6.607,0,0,0,4,7.162,7.1,7.1,0,0,0,7.625,5.6a1.242,1.242,0,0,1,.922-.28,1.229,1.229,0,0,1,.836.46,4.179,4.179,0,0,0,2.92,1.38A3.635,3.635,0,0,0,15.019,5.84a1.25,1.25,0,0,1,1.808-.232,7.253,7.253,0,0,0,3.8,1.555A4.814,4.814,0,0,0,23.73,5.726l0,.005,1.85,1.682a7.312,7.312,0,0,1-4.953,2.249A8.8,8.8,0,0,1,16.181,8.2a5.988,5.988,0,0,1-3.872,1.461A6.4,6.4,0,0,1,8.3,8.186,8.427,8.427,0,0,1,4.028,9.662Z",
    transform: "translate(0.966 12.055)",
    fill: "#2666cf",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59-6",
    "data-name": "Path 59",
    d: "M4.028,9.662h-.05A8.183,8.183,0,0,1-.84,7.454L.93,5.688A6.607,6.607,0,0,0,4,7.162,7.1,7.1,0,0,0,7.625,5.6a1.242,1.242,0,0,1,.922-.28,1.229,1.229,0,0,1,.836.46,4.179,4.179,0,0,0,2.92,1.38A3.635,3.635,0,0,0,15.019,5.84a1.25,1.25,0,0,1,1.808-.232,7.253,7.253,0,0,0,3.8,1.555A4.814,4.814,0,0,0,23.73,5.726l0,.005,1.85,1.682a7.312,7.312,0,0,1-4.953,2.249A8.8,8.8,0,0,1,16.181,8.2a5.988,5.988,0,0,1-3.872,1.461A6.4,6.4,0,0,1,8.3,8.186,8.427,8.427,0,0,1,4.028,9.662Z",
    transform: "translate(0.966 -4.712)",
    fill: "#2666cf",
    opacity: 0.2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOceanIcon);
export default __webpack_public_path__ + "static/media/ocean-icon.3903760008b4628338ae3ad37c14e29c.svg";
export { ForwardRef as ReactComponent };